import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ThemeTest.scss';
import { HeightBounder, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { StaticLogger } from '@nu-art/ts-common';
import { QColorPicker } from '@app/hcs-frontend/ui-components';
import { AppTheme, ModuleFE_Theme } from '@app/styles';
const toggleThemeOption = (option) => {
    const currentProp = ModuleFE_Theme.getThemeProp(option);
    const themeOptions = AppTheme[option];
    let index = themeOptions.indexOf(currentProp) + 1;
    if (index >= themeOptions.length)
        index = 0;
    ModuleFE_Theme.setThemeProp(option, themeOptions[index]);
};
const ThemeTest = () => {
    const onClick = (name) => {
        StaticLogger.logInfo('clicked', name);
    };
    const onBlur = (e, name) => {
        e.nativeEvent.stopImmediatePropagation();
        StaticLogger.logInfo('losing focus:', name);
        return false;
    };
    return _jsx(HeightBounder, { children: _jsxs(LL_H_C, { className: 'theme-test', children: [_jsx("div", { className: 'theme-toggle-button', onClick: () => {
                        toggleThemeOption('theme');
                    }, children: "T" }), _jsx("div", { className: 'device-toggle-button', onClick: () => {
                        toggleThemeOption('device');
                    }, children: "D" }), _jsx("div", { children: "Focus test!" }), _jsxs("div", { style: { width: '400px', height: '400px', background: 'cyan' }, tabIndex: 1, children: [_jsx("div", { style: { width: '100px', height: '100px', background: 'green' }, tabIndex: 1, path: 'green', onClick: () => {
                                onClick('green');
                            }, onBlur: (e) => {
                                onBlur(e, 'green');
                            } }), _jsx("div", { style: { width: '100px', height: '100px', background: 'red' }, tabIndex: 1, path: 'red', onClick: () => {
                                onClick('red');
                            }, onBlur: (e) => {
                                onBlur(e, 'red');
                            } })] }), _jsx(QColorPicker, {})] }) });
};
export const PgDev_ThemeTest = { name: 'Theme Test', key: 'theme-test', renderer: ThemeTest };
